import React from 'react';
import { transLanguage } from '@op/utils';
import { Bubble, Button, Rate } from 'tea-component';
import ReviewBox from '../../ReviewBox';
import BubbleCommon, {
  compareKeyMetricsEngagementTips,
  steamPerformanceMetaStoreTips,
  steamPerformanceStarTaggedTipsInfo,
  TipsMapType,
  chzzkLiveBroadcastViewsTipsText,
  feedsImage,
} from '@op/components/BubbleCommon';
import ChannelLabel from '../../ChannelLabel';
import moment from 'moment';
import ValidDropdown from '@op/components/ValidDropdown';
import ImageGallery from '@op/components/ImageGallery';
import TopicBox from '../../TopicBox';
import RegionCountryItem from '../../Snippets/RegionCountryItem';
import { getLocale } from 'umi';
import SteamRatingColumns from '../../SteamRatingColumns';

import ValidationHeader from './components/ValidationHeader';
import { MetacriticScore } from '../../MetacriticScore';
import { reviewsFormat } from '@op/utils/value';
import { getFeedsReviewsType, keywordRenderFunc } from '@op/utils/text';
import MonitoringShow from './components/MonitoringShow';
import { NO_DATE } from '@op/constants';
import { LanguageType } from '@op/types/common';
import TranslateSelect from '@op/components/FilterBoxCommon/filters/languages';
import GameStoreMonitoringShow from './components/GameStoreMonitoringShow';
import _ from 'lodash-es';
import { FeedsColumnsFuncResultType } from '../types';

function dealwithExtJson(extJson: any) {
  if (extJson) {
    const showArray: Array<string> = [];
    let info: any = {};

    try {
      info = JSON.parse(extJson);

      // console.log(info);
    } catch (error) { }
    _.forOwn(info.reactions, (element: any, key: any) => {
      showArray.push(`${key} ${element}`);
    });
    return showArray;
  }
  return [];
}

function getGameStoreExtJson(
  data: any,
  key: string,
  func?: (value: any) => string,
) {
  if (data.channel_name !== 'steam') return '-';
  try {
    const obj = JSON.parse(data.ext_json);
    const value = obj[key];
    if (value && !func) return value;
    if (func) return func(value);
    return value ?? '-';
  } catch (error) {
    return '-';
  }
}

function getSocialMediaExtJson(
  data: any,
  key: string,
  func?: (value: any) => string | number,
) {
  if (data.channel_name !== 'chzzk') return '-';
  try {
    const obj = JSON.parse(data.ext_json);
    const value = obj[key];
    if (value && !func) return value;
    if (func) return func(value);
    return value || '-';
  } catch (error) {
    return '-';
  }
}

function getIconHeard(channel: any, text: string, tips?: TipsMapType) {
  function getChannelIcon() {
    const icon = (
      <>
        <ChannelLabel
          iconStyle={{ width: 16, height: 16, marginRight: '5px' }}
          channel_name={channel}
          showText={false}
        ></ChannelLabel>
        {text}
      </>
    );

    if (tips) {
      return (
        <BubbleCommon placement="top" tipsMap={tips} showIcon={false}>
          {icon}
        </BubbleCommon>
      );
    }

    return icon;
  }

  return <div className="dbo-tablecommon-header">{getChannelIcon()}</div>;
}

const threeStyle: any = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: '3',
  WebkitBoxOrient: 'vertical',
};

const refundedMap: any = {
  0: 'No',
  1: 'Yes',
};

export type keys =
  | 'like'
  | 'share'
  | 'comment'
  | 'view'
  | 'follower'
  | 'engagement'
  | 'validation'
  | 'topic'
  | 'language'
  | 'commentTime'
  | 'channelName'
  | 'monitoring'
  | 'ctgr1'
  | 'ctgr2'
  | 'ctgr3'
  | 'origin'
  | 'en'
  | 'zh'
  | 'rating'
  | 'market'
  | 'version';

function getContentInfo(
  content: string,
  renderKey: string | Array<string>,
  sentimentStr?: string,
) {
  return keywordRenderFunc({
    text: content,
    keyword: renderKey,
    sentimentInfo: sentimentStr,
    titleCase: true,
  });
}

function getUpdateFilter(cvm: any) {
  return {
    unified_id: cvm.unified_id,
    edition_id: cvm.edition_id,
    comment_time: moment(cvm.comment_time).format('YYYY-MM-DD HH:mm:ss'),
    comment_uin: cvm.comment_uin,
    comment_create_time: moment(cvm.create_time).format('YYYY-MM-DD HH:mm:ss'),
  };
}

export type FeedsColumnsFuncType = {
  formatMessage: any;
  renderKey: any;
  firstLanguage: any;
  topicList: { topic_trans: Array<any>; key_topic: any };
  entityType: any;
  sort: any;
  setSort: any;
  excludeInvalidInfo: any;
  showSentiment: any;
  total: any;
  logCommentMap: any;
  logLoading: any;
  MergeChannelIconElement?: any;
  languages: Array<LanguageType>;
  setLanguages: (value: Array<LanguageType>) => void;
  detailParams?: any;
  isSocialMedia?: boolean;
  wholeGameInfo?: any;
};

/**
 * 对象中返回sortKey，然后通过sortKey确定那些字段排序，同时也给排序选项做数据源
 * @param param0
 * @returns
 */
export const feedsColumnsFunc = ({
  formatMessage,
  renderKey,
  firstLanguage,
  topicList,
  entityType,
  sort,
  setSort,
  excludeInvalidInfo,
  showSentiment,
  total,
  logCommentMap,
  logLoading,
  MergeChannelIconElement,
  languages,
  setLanguages,
  detailParams,
  isSocialMedia = false,
  wholeGameInfo
}: FeedsColumnsFuncType): FeedsColumnsFuncResultType => {
  const isString = typeof renderKey === 'string';
  function dealwithSteamStore(value: number) {
    return value === 1
      ? formatMessage({ id: 'Yes' })
      : formatMessage({ id: 'No' });
  }
  function dealwithSteamStarred(value: number) {
    return value === 1
      ? formatMessage({ id: 'No' })
      : formatMessage({ id: 'Yes' });
  }

  function dealwithTitleText(show: boolean, text: string) {
    const totalText = total !== undefined ? '(Total items: {total})' : '';
    const translation = show ? (
      <TranslateSelect
        onChange={(key: string, value: any) => setLanguages?.(value)}
        key={'languages'}
        defaultValue={['origin']}
        defaultParams={{ value: languages }}
      // TODO: 暂时屏蔽无中文翻译
      // chineseDisabled={DBO_GAME.isNormal(wholeGameInfo)}
      />
    ) : null;
    if (show && totalText) {
      return (
        <div className="dbo-table-header-reviews">
          {formatMessage({ id: `${text}${totalText}` }, { total })}
          {translation}
        </div>
      );
    }

    return (
      <div className="dbo-table-header-reviews">
        {formatMessage({ id: text })}
        {translation}
      </div>
    );
  }

  return {
    feedsPlatform: {
      key: 'platform',
      header: formatMessage({ id: 'Platform' }),
      width: 160,
    },
    monitorSource: {
      key: 'monitor_source',
      header: formatMessage({ id: 'Monitor Source' }),
      width: 170,
      render: (cvm: any) => (
        <GameStoreMonitoringShow
          monitor_source={cvm?.monitor_source}
        ></GameStoreMonitoringShow>
      ),
    },
    reviewsType: {
      key: 'reviewsType',
      header: formatMessage({ id: 'Review Type' }),
      align: 'left',
      width: 150,
      render: (cvm) => {
        const value = getFeedsReviewsType(cvm);

        return (
          <p
            style={{
              overflow: 'auto',
              whiteSpace: 'break-spaces',
              wordBreak: 'break-word',
            }}
          >
            {formatMessage({ id: value || NO_DATE.EMPTY })}
          </p>
        );
      },
    },
    version: {
      key: 'version',
      tableSort: true,
      header: formatMessage({ id: 'Version' }),
      align: 'left',
      width: 130,
    },
    market: {
      key: 'market',
      header: formatMessage({ id: 'Market' }),
      width: 160,
      render: (cvm: any) => {
        const { market } = cvm;

        return <RegionCountryItem market={market}></RegionCountryItem>;
      },
    },
    rating: {
      key: 'comment_score',
      header: formatMessage({ id: 'Rating' }),
      width: entityType === 'pc' ? 185 : 150,
      render: (cvm: any) => {
        const { channel_name, comment_score } = cvm;
        const channelName = channel_name.toLowerCase().trim();
        if (channelName === 'steam') {
          return <SteamRatingColumns {...cvm} />;
        }

        if (channelName === 'opencritic' || channelName === 'metacritic') {
          return <MetacriticScore data={cvm}></MetacriticScore>;
        }

        return (
          <div className="dbo-ratingstar">
            <Rate readonly theme="primary" allowHalf value={comment_score} />
            <span className="dbo-ratingstar-text">
              {/* 这是显示整数，开发需要注意处理数据 */}
              {Number(comment_score).toFixed(1)}
            </span>
          </div>
        );
      },
    },
    origin: {
      key: 'reviews_ori',
      header: dealwithTitleText(true, 'Reviews in Original Language'),
      width: 520,
      fixed: 'left',
      render: (cvm: any) => (
        <ReviewBox
          // 源语言评论不支持编辑
          editable={false}
          data={cvm}
          link={cvm.content_url}
          columnsIsFirst
          sentiment={cvm.sentiment_rating}
          editTranslate={cvm.content}
          content={getContentInfo(
            cvm.content,
            isString ? renderKey : renderKey?.origin,
          )}
          originContent={cvm.content}
          filter={getUpdateFilter(cvm)}
          language="origin"
          username={cvm.reviewer}
          logCommentMap={logCommentMap}
          logLoading={logLoading}
          detailParams={detailParams}
          isSocialMedia={isSocialMedia}
        ></ReviewBox>
      ),
    },
    en: {
      key: 'reviews_eng',
      header: dealwithTitleText(firstLanguage === 'en', 'Reviews in English'),
      align: 'left',
      fixed: firstLanguage === 'en' ? 'left' : undefined,
      width: 520,
      render: (cvm: any) => (
        <ReviewBox
          editable={true}
          data={cvm}
          link={cvm.content_url}
          language="en"
          filter={getUpdateFilter(cvm)}
          content={getContentInfo(
            cvm.content_to_en,
            isString ? renderKey : renderKey?.en,
            showSentiment ? cvm.ext1_str : undefined,
          )}
          sentiment={cvm.sentiment_rating}
          columnsIsFirst={firstLanguage === 'en'}
          // 中文： 2， 英文：3
          languageType={3}
          editTranslate={cvm.content_to_en}
          originContent={cvm.content}
          username={cvm.reviewer}
          languageTitle="English"
          logCommentMap={logCommentMap}
          logLoading={logLoading}
          detailParams={detailParams}
          isSocialMedia={isSocialMedia}
        ></ReviewBox>
      ),
    },
    zh: {
      key: 'reviews_ch',
      header: dealwithTitleText(firstLanguage === 'zh', 'Reviews in Chinese'),
      align: 'left',
      fixed: firstLanguage === 'zh' ? 'left' : undefined,
      width: 520,
      render: (cvm: any) => {
        // TODO: 需求确认暂时屏蔽
        // if ([0, '0'].includes(cvm.isvalid)) {
        //   return <div style={{ color: "#838697" }}>{formatMessage({ id: "Invalid reviews are not supported for Chinese translation." })}</div>;
        // }
        return (
          <ReviewBox
            editable={true}
            data={cvm}
            link={cvm.content_url}
            language="zh"
            sentiment={cvm.sentiment_rating}
            columnsIsFirst={firstLanguage === 'zh'}
            filter={getUpdateFilter(cvm)}
            content={getContentInfo(
              cvm.content_to_zh,
              isString ? renderKey : renderKey?.zh,
            )}
            username={cvm.reviewer}
            // 中文： 2， 英文：3
            languageType={2}
            editTranslate={cvm.content_to_zh}
            originContent={cvm.content}
            languageTitle="Chinese"
            logCommentMap={logCommentMap}
            logLoading={logLoading}
            detailParams={detailParams}
            isSocialMedia={isSocialMedia}
          ></ReviewBox>
        );
      },
    },
    refunded: {
      key: 'refunded',
      header: formatMessage({ id: 'Refunded' }),
      align: 'left',
      width: 150,
      render: (cvm: any) => {
        if (cvm.channel_name !== 'steam') return '-';
        return formatMessage({
          id: refundedMap[cvm?.refunded] || NO_DATE.EMPTY,
        });
      },
    },
    steamPurchase: {
      key: 'steam_purchase',
      header: getIconHeard('steam', formatMessage({ id: 'Steam Purchase' })),
      align: 'left',
      width: 200,
      render: (cvm: any) =>
        getGameStoreExtJson(cvm, 'steam_purchase', dealwithSteamStore),
    },
    ctgr1: {
      key: 'ctgr_1',
      header: 'CTGR1',
      width: 180,
      align: 'center',
    },
    ctgr2: {
      key: 'ctgr_2',
      header: 'CTGR2',
      width: 180,
      align: 'center',
    },
    ctgr3: {
      key: 'ctgr_3',
      header: 'CTGR3',
      width: 180,
      align: 'center',
    },
    dislike: {
      key: 'tweets_unlike',
      tableSort: true,
      header: formatMessage({ id: 'Dislike' }),
      align: 'right',
      width: 110,
      render: (cvm: any) => {
        if (Number(cvm.tweets_unlike) < 1) {
          return '-';
        }
        return reviewsFormat(cvm.tweets_unlike);
      },
    },
    like: {
      key: 'tweets_like',
      tableSort: true,
      header: formatMessage({ id: 'Like' }),
      align: 'right',
      width: 110,
      render: (cvm: any) => {
        if (Number(cvm.tweets_like) < 1) {
          return '-';
        }
        return reviewsFormat(cvm.tweets_like);
      },
    },
    like2: {
      key: 'tweets_like',
      tableSort: true,
      sortKey: 'Votes',
      header: formatMessage({ id: 'Votes' }),
      align: 'right',
      width: 110,
      render: (cvm: any) => {
        if (Number(cvm.tweets_like) < 1) {
          return '-';
        }
        return reviewsFormat(cvm.tweets_like);
      },
    },
    share: {
      key: 'share',
      tableSort: true,
      header: formatMessage({ id: 'Share-2' }),
      align: 'right',
      width: 120,
      render: (cvm: any) => {
        if (Number(cvm.tweets_retweet) < 1) {
          return '-';
        }
        return reviewsFormat(cvm.tweets_retweet);
      },
    },
    comment: {
      key: 'tweets_reply',
      tableSort: true,
      header: formatMessage({ id: 'Comment' }),
      align: 'right',
      width: 135,
      render: (cvm: any) => {
        if (Number(cvm.tweets_reply) < 1) {
          return '-';
        }
        if ('0' == cvm.tweets_reply) {
          return '0';
        }

        const a = reviewsFormat(cvm.tweets_reply);

        return cvm.keyword_or_account === 'account' ? (
          <Button
            className="dbo-tablecommon-link"
            type="link"
            onClick={() => { }}
          >
            {a}
          </Button>
        ) : (
          <p>{a}</p>
        );
      },
    },
    view: {
      key: 'view',
      tableSort: true,
      header: formatMessage({ id: 'View' }),
      align: 'right',
      width: 120,
      render: (cvm: any) => {
        if (Number(cvm.view) < 1) {
          return '-';
        }
        return reviewsFormat(cvm.view);
      },
    },
    tweetsReply: {
      key: 'tweets_reply',
      tableSort: true,
      header: formatMessage({ id: 'Replies' }),
      width: 120,
      align: 'center',
      render: (cvm: any) => {
        if (Number(cvm.tweets_reply) < 1) {
          return '-';
        }
        if ('0' == cvm.tweets_reply) {
          return '0';
        }
        return reviewsFormat(cvm.tweets_reply);
      },
    },
    liveViews: {
      key: 'live_views',
      header: getIconHeard(
        'chzzk',
        formatMessage({ id: 'Live Broadcast Views' }),
        chzzkLiveBroadcastViewsTipsText,
      ),
      align: 'right',
      width: 300,
      render: (cvm: any) =>
        getSocialMediaExtJson(cvm, 'live_count', reviewsFormat),
    },
    follower: {
      key: 'follower_number',
      tableSort: true,
      header: formatMessage({ id: 'Follower/Subscriber' }),
      align: 'right',
      width: getLocale() === 'en-US' ? 220 : 170,
      render: (cvm: any) => {
        if (Number(cvm.subscribe) < 1) {
          return '-';
        }
        return reviewsFormat(cvm.subscribe);
      },
    },
    engagement: {
      key: 'engagement',
      tableSort: true,
      header: (
        <div className="dbo-tablecommon-header">
          <span> {formatMessage({ id: 'Engagement' })} </span>
          <BubbleCommon
            tipsMap={compareKeyMetricsEngagementTips}
            extraContent={
              MergeChannelIconElement && (
                <MergeChannelIconElement
                  metric={'engagement'}
                ></MergeChannelIconElement>
              )
            }
          ></BubbleCommon>
        </div>
      ),
      align: 'right',
      width: getLocale() === 'en-US' ? 180 : 128,
      render: (cvm: any) => {
        if (Number(cvm.engagement) < 1) {
          return '-';
        }
        return reviewsFormat(cvm.engagement);
      },
    },
    description: {
      key: 'description',
      header: formatMessage({ id: 'Description' }),
      align: 'left',
      width: 200,
      render: (cvm: any) => (
        <Bubble closeOnScroll dark content={cvm.description}>
          <div className="text-show-info">{cvm.description}</div>
        </Bubble>
      ),
    },
    images: {
      key: 'images',
      header: (
        <div className='dbo-tablecommon-header'>
          {formatMessage({ id: 'Images' })}
          <BubbleCommon tipsMap={feedsImage} />
        </div>
      ),
      align: 'left',
      width: 130,
      render: (cvm: any) => (
        <ImageGallery images={cvm?.media_images} />
      ),
    },
    validation: {
      key: 'isvalid',
      sortKey: 'sort_isvalid',
      tableSort: false,
      width: 180,
      header: (
        <ValidationHeader
          sort={sort}
          setSort={setSort}
          excludeInvalidInfo={excludeInvalidInfo}
        ></ValidationHeader>
      ),
      align: 'left',
      render: (cvm: any) => (
        <ValidDropdown
          data={cvm}
          needRequest={false}
          logCommentMap={logCommentMap}
          validLoading={logLoading}
        />
      ),
    },
    topic: {
      key: 'topic',
      header: formatMessage({ id: 'Topic' }),
      align: 'left',
      width: 270,
      render: (cvm: any) => (
        <TopicBox
          logCommentMap={logCommentMap}
          topicLoading={logLoading}
          data={cvm}
          needRequest={false}
          topicList={topicList}
        />
      ),
    },
    language: {
      key: 'language',
      header: formatMessage({ id: 'Language' }),
      align: 'left',
      width: 110,
      render: (cvm: any) => transLanguage(cvm?.language),
    },
    commentTime: {
      key: 'comment_time',
      tableSort: true,
      header: formatMessage({ id: 'Time' }),
      align: 'left',
      width: 165,
      render: (cvm: any) => moment(cvm.comment_time).format('YYYY-MM-DD HH:mm'),
    },
    commentTime2: {
      key: 'comment_time',
      tableSort: true,
      sortKey: 'ReleaseTime',
      header: formatMessage({ id: 'Release Time' }),
      align: 'left',
      width: 165,
      render: (cvm: any) => moment(cvm.comment_time).format('YYYY-MM-DD HH:mm'),
    },
    updateTime: {
      key: 'update_time',
      header: formatMessage({ id: 'Latest Update Time' }),
      width: 180,
      render: (cvm: any) =>
        cvm.ctgr_1 ? moment(cvm.ctgr_1).format('YYYY-MM-DD HH:mm') : '',
    },
    channelName: {
      key: 'channel_name',
      header: formatMessage({ id: 'Channel' }),
      width: 160,
      render: (cvm: any) => <ChannelLabel channel_name={cvm.channel_name} />,
    },
    monitoring: {
      key: 'monitoring',
      header: formatMessage({ id: 'Monitoring Source' }),
      align: 'left',
      width: 230,
      render: (cvm: any) => {
        const { monitor_source } = cvm;
        return (
          <div className="dbo-tablecommon-line">
            <MonitoringShow monitor_source={monitor_source}></MonitoringShow>
          </div>
        );
      },
    },
    reactions: {
      key: 'Reactions',
      header: formatMessage({ id: 'Reactions-1' }),
      width: 120,
      render: (cvm: any) => {
        const text = dealwithExtJson(cvm?.ext_json);

        const showText = text.join(',');
        return (
          <Bubble closeOnScroll dark content={showText}>
            <span style={threeStyle}>{showText}</span>
          </Bubble>
        );
      },
    },
    steamId: {
      key: 'SteamId',
      header: getIconHeard('steam', formatMessage({ id: 'Steam ID' })),
      width: 220,
      render: (cvm: any) => getGameStoreExtJson(cvm, 'user_id'),
    },
    starred: {
      key: 'starred',
      header: getIconHeard(
        'steam',
        formatMessage({ id: 'Starred Tag' }),
        steamPerformanceStarTaggedTipsInfo,
      ),
      width: 170,
      render: (cvm: any) =>
        getGameStoreExtJson(cvm, 'unstarred', dealwithSteamStarred),
    },
    receivedForFreeTag: {
      key: 'receivedForFreeTag',
      header: getIconHeard('steam', formatMessage({ id: 'Free Played' })),
      width: 200,
      render: (cvm: any) =>
        getGameStoreExtJson(cvm, 'received_free', dealwithSteamStore),
    },
    earlyAccessTag: {
      key: 'earlyAccessTag',
      header: getIconHeard(
        'steam',
        formatMessage({ id: 'Early Access Reviews' }),
      ),
      width: 210,
      render: (cvm: any) =>
        getGameStoreExtJson(cvm, 'early_access', dealwithSteamStore),
    },
    funny: {
      key: 'funny_num',
      tableSort: true,
      header: getIconHeard('steam', formatMessage({ id: 'Funny(people)' })),
      width: 192,
      align: 'right',
      render: (cvm: any) => getGameStoreExtJson(cvm, 'funny_num'),
    },
    helpful: {
      key: 'helpful_num',
      tableSort: true,
      header: getIconHeard('steam', formatMessage({ id: 'Helpful(people)' })),
      width: 202,
      align: 'right',
      render: (cvm: any) => getGameStoreExtJson(cvm, 'helpful_num'),
    },
    meta_dislike: {
      key: 'tweets_unlike',
      tableSort: true,
      header: getIconHeard(
        'meta_store',
        formatMessage({ id: 'Dislike' }),
        steamPerformanceMetaStoreTips,
      ),
      align: 'right',
      width: 130,
      render: (cvm: any) => {
        if (Number(cvm.tweets_unlike) < 1) {
          return '-';
        }
        return reviewsFormat(cvm.tweets_unlike);
      },
    },
    meta_like: {
      key: 'tweets_like',
      tableSort: true,
      header: getIconHeard(
        'meta_store',
        formatMessage({ id: 'Like' }),
        steamPerformanceMetaStoreTips,
      ),
      align: 'right',
      width: 130,
      render: (cvm: any) => {
        if (Number(cvm.tweets_like) < 1) {
          return '-';
        }
        return reviewsFormat(cvm.tweets_like);
      },
    },
  };
};
